import React, { ReactElement } from 'react';
import type { Route } from 'next';
import Link from 'next/link';
import classNames from 'classnames/bind';
import { benefitsCards } from 'sections/Home/data';
import Card from 'sections/Home/components/Card';
import styles from 'sections/Home/components/SectionBenefits/SectionBenefits.module.scss';

const cn = classNames.bind(styles);

const SectionBenefits = (): ReactElement => {
  const cardItems = benefitsCards.map((card) => {
    return (
      <Card className={cn('card', `${card.className ?? ''}`)} key={card.icon}>
        <div className={cn('card__content')}>
          <Card.Header className={cn('card__title-box')}>
            <div className={cn('card__icon')}>
              <img src={`/images/pages/Home/${card.icon}`} alt={card.alt} />
            </div>
            <h3 className={cn('card__title')}>{card.title}</h3>
          </Card.Header>
          <Card.Content className={cn('card__description')}>
            <p>{card.description}</p>
          </Card.Content>
        </div>
        {card.link
          ?
          <Card.Footer className={cn('card__buttons')}>
            <Link className={cn('card__button-more')} href={card.link as Route}>
              Learn more
              <svg viewBox="0 0 10 10" aria-hidden="true">
                <path d="M1 5h7" />
                <path d="M2 1l4 4-4 4" />
              </svg>
            </Link>
          </Card.Footer>
          :
          null
        }
      </Card>
    );
  });

  return (
    <section className={cn('benefits')}>
      <div className={cn('container')}>
        <div className={cn('benefits__heading-box')}>
          <h2 className={cn('benefits__heading')}>Freight Network Benefits</h2>
          <p className={cn('benefits__description')}>
            Digital Freight Alliance Network provides benefits to support association members to get ahead:
          </p>
        </div>
        <div className={cn('benefits__cards')}>{cardItems}</div>
      </div>
    </section>
  );
};

export default SectionBenefits;